import React, {useState, useEffect} from 'react'
import Nav from './components/Nav';
import { Routes, Route} from 'react-router-dom'
import Home from './components/Home';
import Resume from './components/Resume';
import Contact from './components/Contact';
import ProjectDetails from './components/ProjectDetails';
import Blogs from './components/Blogs';
import Blog from './components/Blog';
function App() {
 
  return (
    <Nav className={`bg-[url("https://flevix.com/wp-content/uploads/2020/01/Fade-In-Background.svg"]`}>
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/resume' element={<Resume></Resume>}></Route>
        <Route path='/contact' element={<Contact></Contact>}></Route>
        <Route path='/blogs' element={<Blogs></Blogs>}></Route>
        <Route path='/blogs/:id' element={<Blog></Blog>}></Route>
        <Route path='/projects/:id' element={<ProjectDetails></ProjectDetails>}></Route>
      </Routes>
    </Nav>
  );
}

export default App;
